import { TabButton } from '@/components/shared/atoms/TabButton'
import type { LucideIcon } from 'lucide-react'

interface Tab {
    value: string
    label: string
    icon?: LucideIcon
}

interface TabNavigationProps {
    tabs: Tab[]
    activeTab: string
    setActiveTab: (tabId: string) => void
    variant?: 'search' | 'profile' | 'default'
}

export function TabNavigation({
    tabs,
    activeTab,
    setActiveTab,
    variant = 'default',
}: TabNavigationProps) {
    const getBackgroundClasses = () => {
        switch (variant) {
            case 'search':
                return 'bg-white md:bg-[var(--color-bg)]'
            case 'profile':
                return 'bg-white md:bg-[#1A1A1A]'
            case 'default':
            default:
                return 'bg-white md:bg-[#1A1A1A]'
        }
    }

    const getActiveTabClasses = () => {
        switch (variant) {
            case 'search':
                return '' // Use default TabButton styling (black border)
            case 'profile':
                return 'md:!rounded-none md:!border-b-4 md:!border-[#FAF7F3] md:text-[#FAF7F3]'
            case 'default':
            default:
                return 'md:!rounded-none md:!border-b-4 md:!border-[#FAF7F3] md:text-[#FAF7F3]'
        }
    }

    return (
        <div
            className={`sticky top-safe z-10 mx-auto mb-4 md:static md:top-14 ${getBackgroundClasses()}`}
        >
            <div className="mx-auto flex border-b border-b-[#e6e6e6] md:max-w-xs">
                {tabs.map((tab) => (
                    <TabButton
                        className={
                            activeTab === tab.value ? getActiveTabClasses() : ''
                        }
                        key={tab.value}
                        active={activeTab === tab.value}
                        onClick={() => setActiveTab(tab.value)}
                    >
                        <span className="relative inline-block">
                            {tab.label}
                            {tab.icon && (
                                <tab.icon className="absolute -top-1 -right-3 h-3 w-3 text-[#858585]" />
                            )}
                        </span>
                    </TabButton>
                ))}
            </div>
        </div>
    )
}
